// extracted by mini-css-extract-plugin
module.exports = {"button-style":"ButtonSolid_button-style__Km14a","button-style-cancel":"ButtonSolid_button-style-cancel__Ny3v0","button-style-detail":"ButtonSolid_button-style-detail__Vi1CW"};